const LangFooter = {
	"footer.footerMenu._Change_Region": ["Change Language", "ប្តូរ​ភាសា"],
	"footer.footerMenu._English": ["English", "អង់​គ្លេស​"],
	"footer.footerMenu._Khmer": ["Khmer", "ខ្មែរ​"],
	"footer._copyright": [
		"© 2019 Starbucks Corporation. All rights reserved.",
		"© 2019 Starbucks Corporation. All rights reserved.",
	],
}

export default LangFooter



// WEBPACK FOOTER //
// ./src/resources/modules/LangFooter.js